import React, { FC } from 'react';
import { AlternativeItineraryDoubleCardDropdownLayerTitleProps } from '@components/AlternativeItineraryDoubleCard/components/AlternativeItineraryDoubleCardLayer/types';
import { Box, Flex, Glyph, Heading } from '@edreamsodigeo/prisma-design-system';

const AlternativeItineraryDoubleCardDropdownLayerTitle: FC<
  AlternativeItineraryDoubleCardDropdownLayerTitleProps
> = ({ children, sx, isTopSectionExpanded, onClick }) => {
  const iconColor = 'neutral.90';
  const ChevronDown = () => (
    <Glyph
      category="Arrows"
      name="ChevronDown"
      size="medium"
      data-testid="chevron-down"
      sx={{ color: iconColor }}
    />
  );
  const ChevronUp = () => (
    <Glyph
      category="Arrows"
      name="ChevronUp"
      size="medium"
      data-testid="chevron-up"
      sx={{ color: iconColor }}
    />
  );
  return (
    <Flex
      width="100%"
      justifyContent="space-between"
      alignItems={'center'}
      sx={{ ...sx }}
      onClick={onClick}
    >
      <Box data-testid="alternative-itinerary-dropdown-layer-title">
        <Heading type="3" weight="medium" color={iconColor}>
          {children}
        </Heading>
      </Box>
      <Box>{isTopSectionExpanded ? <ChevronUp /> : <ChevronDown />}</Box>
    </Flex>
  );
};

export default AlternativeItineraryDoubleCardDropdownLayerTitle;
